import { FC } from 'react'
import clsx from 'clsx'
import { useAppDispatch, useAppSelector } from '../../hooks/useStore'
import {
  handleSidebarSelectMenu,
  toggleSidebar,
} from '../../store/features/dashboardUi/dashboardUiSlice'
import MenuIcon from '../../components/menuIcon/MenuIcon'
import ArrowIcon from './ArrowIcon'
import { MenuListProps } from '../types'

type IProps = MenuListProps

const MenuListItem: FC<IProps> = ({ id, hasSubMenu, Icon, title }) => {
  const { isToggle, selectedMenu } = useAppSelector((state) => state.dashboardUi.sidebar)
  const dispatch = useAppDispatch()

  const handleSelectedMenu = (name: string) => {
    // toggle display submenu
    selectedMenu === name && !isToggle
      ? dispatch(handleSidebarSelectMenu(''))
      : dispatch(handleSidebarSelectMenu(name))

    // if sidebar is toggle after click on icon sidebar show
    isToggle && dispatch(toggleSidebar(false))
  }

  return (
    <section
      className={clsx(
        'flex justify-between items-center cursor-pointer px-2 my-4 hover:text-blue-400 hover:border-blue-400 border-r-2 border-neutral-50 duration-300 ease-in-out',
        id === selectedMenu ? 'text-blue-400 border-blue-400' : 'text-gray-400',
      )}
      onClick={() => handleSelectedMenu(id)}
    >
      <div className='flex items-center '>
        <MenuIcon Icon={Icon} title={title} />
        <span className={clsx('flex items-center text-sm mr-2', isToggle ? 'hidden' : 'block')}>
          {title}
        </span>
      </div>

      {/* Arrow */}
      {hasSubMenu && <ArrowIcon id={id} />}
    </section>
  )
}

export default MenuListItem
